<template>
  <!-- 解决方案 -->
  <div id="fangan">
    <!-- banner  -->
    <section class="fbnr">
      <img src="../../assets/jpcol/fanganbanner_sample.png" alt="" />
    </section>

    <section class="w_10ff pad50"><fanmenu /></section>
    <section><fangancont /></section>

  </div>
</template>

<script>

import fanmenu from "./child/fanmenu";
import fangancont from "./child/fangancont";

export default {
  name: "zuiming",
  components: {
    // 私
    fanmenu,
    fangancont,

  },
  created() {
	  
  	console.log(this.$route.params)
  },
  methods:{
	  // getsolu() {
	  //   let data = {
	  //     page: this.currentPage,
	  //     cat_id: this.catId,
	  //     limit: 6,
	  //   };
	  //   data.cat_id == 0 ? delete data.cat_id : "";
	  //   this.$http.jpcol
	  //     .getsolutionlist(data)
	  //     .then((res) => {
	  //       this.pageCount = res.data.last_page;
	  //       this.total = res.data.count;
	  //       this.solulist = res.data.data;
	  //     })
	  //     .catch((err) => {});
	  // },
  }
};
</script>

<style lang="scss" scoped>
#fangan {
  background-color: #f8f8f8;
  .fbnr {
    max-width: 1920px;
    width: 100%;
	height: 430px;
    overflow: hidden;
    margin: 0 auto;
    img {
      width: 1920px;
    }
  }
  .w_10ff {
    width: 100%;
    background-color: #fff;
  }
  .pad50 {
    padding: 50px 0;
  }
}
</style>